export const USER_CREATED =
    'Usuario creado. Se le envió un email con instrucciones'
export const USER_DELETD = 'Usuario eliminado'
export const USER_UPDATED = 'Información actualizada'
export const MEMBERSHIP_DEACTIVATED = 'Membresia desactivada'
export const MEMBERSHIP_ACTIVATED = 'Membresia activada'

export const USER_NOT_FOUND = 'El usuario no existe'
export const PASSWORD_UPDATED = 'Contraseña actualizada con exito'
